<template lang="pug">
.register.height-100
   .frow
      .box
        h1.title-call-out Register
        .frow.row-center(v-if="!accountCreated")
          p.control
            form(@keydown="errors.clear($event.target.name)")
              input(name="email" v-model="email" type="text" placeholder="Email" required)
              input(name="password" v-model="password" type="password" placeholder="Password" required)
              input(name="passwordConfirm" v-model="passwordConfirm" type="password" placeholder="Password Confirm")
          .frow.column-center
            .errors(v-if="responseErrors.length > 0")
              .error(v-for="error in responseErrors")
                | {{ error.message }}
            h5 Already have an account?&nbsp;
              router-link.clr-primary(to="login") Login
            VButton(
              text="Register"
              @click.native="register"
            )
        span.frow.column(v-else)
          | Account created successfully!
          div
            | Please click&nbsp;
            router-link(to="/login") here
            | &nbsp;to log in.
</template>
<script>
class Errors {
  constructor() {
    this.errors = {};
  }

  has(field) {
    return this.errors.hasOwnProperty(field);
  }

  get(field) {
    if (this.errors[field]) {
      return this.errors[field];
    }
  }

  record(errors) {
    return (this.errors = errors);
  }

  clear(field) {
    delete this.errors[field];
  }
}

export default {
  name: "register",
  data: () => ({
    errors: new Errors(),
    email: "",
    password: "",
    passwordConfirm: "",
    accountCreated: false,
    responseErrors: []
  }),
  methods: {
    register() {
      if (!this.email) {
        console.log("NO EMAIL");
        this.errors.record("email");
        alert("Please enter an email");
        return;
      }

      if (!this.password) {
        console.log("NO PASSWORD");
        this.errors.record("no-password");
        alert("Please enter a password");
        return;
      }

      if (this.password !== this.passwordConfirm) {
        console.log("PASSWORS DON'T MATCH");
        this.errors.record("passwords-dont-match");
        alert("Passwords don't match!");

        return;
      }

      this.axios
        .post(`${this.$API}/auth/local/register`, {
          email: this.email,
          username: this.email,
          password: this.password
        })
        .then(response => {
          if (response.status == 200) {
            this.accountCreated = true;
            // this.$router.push('login');
          }
        })
        .catch(error => {
          this.responseErrors = error.response.data.message[0].messages;
        });
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push("dashboard");
    }
  }
};
</script>
<style lang="scss" scoped>
input {
  margin-bottom: 10px;
  width: 400px;
}
.box {
  width: 500px;
}
.error {
  color: $red;
}
</style>
